/**
 * ChangeProps参数说明
 * @memberof BillHeadInfo
 * @typedef ChangeProps
 * @property {boolean} showBackBtn=true 是否显示返回按钮
 * @property {boolean} showBillCode=true  是否显示单据号
 * @property {string} billCode 设置单据号
 * @property {string} title 设置标题
*/

/**
 * 修改标题区显示属性
 * @memberof BillHeadInfo
 * @param {ChangeProps} props
 */
export function setBillHeadInfoVisible(data) {
    if (this.myBillInfo && this.myBillInfo.state && data) {
        //控制返回按钮
        if (data.hasOwnProperty('showBackBtn')) {
            if (data.showBackBtn != this.myBillInfo.state.showBackBtn) {
                this.myBillInfo.state.showBackBtn = data.showBackBtn;
            }
        }
        //控制单据编号
        if (data.hasOwnProperty('showBillCode')) {
            if (data.showBillCode != this.myBillInfo.state.showBillCode) {
                this.myBillInfo.state.showBillCode = data.showBillCode;
            }
        }

        //修改单据编号
        if (data.hasOwnProperty('billCode')) {
            if (data.billCode != this.myBillInfo.state.billCode) {
                this.myBillInfo.state.billCode = data.billCode;
            }
        }

        //修改标题
        if (data.hasOwnProperty('title')) {
            if (data.title != this.myBillInfo.state.title) {
                this.myBillInfo.state.title = data.title;
            }
        }
        //控制标签显示隐藏
        if (data.hasOwnProperty('tag')) {
            this.myBillInfo.setState({ tagVisibility:data.tag });
        }
        let { tagsInfo, ...otherState } = this.myBillInfo.state; 
        this.myBillInfo.setState(   
            otherState, //不覆盖tagsInfo
        );

    }
}
//更新标题组件  影响效率，暂时废弃
// export function update() {
// if (this.myBillInfo && this.myBillInfo.state) {
//     this.myBillInfo?.forceUpdate?.();
// }
// }